import script from "./RateGroupActionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RateGroupActionMenu.vue?vue&type=script&setup=true&lang=js"

import "./RateGroupActionMenu.vue?vue&type=style&index=0&id=15100a14&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15100a14"]])

export default __exports__